import { ECurrency, EGameType } from '../../../../types/enums'
import type { PrivateTableSettingsType } from '../types'

export const initialPrivateTableSettings: PrivateTableSettingsType = {
  gameType: EGameType.NLH,
  password: '',
  minPlayers: 2,
  maxPlayers: 6,
  minBuyIn: 100,
  maxBuyIn: 500,
  currency: ECurrency.USD,
  smallBlind: 1,
  bigBlind: 2,
  turnSeconds: 20,
  dealDelaySeconds: 10,
  rakePercent: 0,
  rakeThreshold: 0,
  straddleMin: null,
  straddleMax: null,
  isDoubleBoardPossible: false,
  bombPotMin: null,
  bombPotMax: null,
  bombPotActivateDoubleBoard: true,
  bombPotFrequency: 2,
  // payToSeeBoard: false,
}
